import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Button, TextField } from '@shopify/polaris';
import { CalendarIcon } from '@shopify/polaris-icons';
import { setSeconds } from 'date-fns';
import { useState } from 'react';

const theme = createTheme();
/**
 * Shopify does not have a DateTimePicker, only a DatePicker, so we are using Material-UI's variation to help us.
 * (Moved from the deprecated @mui/lab picker to @mui/x-date-pickers — same component, same props.)
 */

export const ShopifyDateTimePicker: React.FC<{
  label: string;
  value: number;
  onChange: (val: number) => void;
  error?: string;
}> = ({ label, value, onChange, error }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateTimePicker
          renderInput={(props) => {
            return (
              <TextField
                autoComplete="off"
                label={label}
                connectedLeft={
                  <div ref={props.inputRef}>
                    <Button icon={CalendarIcon} onClick={() => setIsOpen(true)}></Button>
                  </div>
                }
                value={(props.inputProps?.value as string) ?? ''}
                onChange={(val) => {
                  onChange(Date.parse(val));
                }}
                error={error}
              />
            );
          }}
          minDateTime={new Date()}
          open={isOpen}
          onClose={() => setIsOpen(false)}
          onChange={(date: Date | null) => {
            date && onChange(date.getTime());
          }}
          value={setSeconds(value, 0)}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
};
